export default "__VITE_ASSET__DFgRQdkb__"